import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import Cookies from "js-cookie";
import { Alert, Col, Container, Row, Form, Button } from 'react-bootstrap';
import { toggleCollapsedNav } from '../redux/action/Theme';
import requester from "../library/Requester";
import * as Actions from './actions/ActionCenter';
import * as util from '../library/utilitys';
import logoOrange from '../assets/img/Logo-th.png';
import leftSideBg from '../assets/img/Login1_0.png';
import SendEmailResetPassword from './SendEmailResetPassword';
import withRouter from './components/withRouter';

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            csrfToken: localStorage.getItem("csrfToken") || null,
            authToken: localStorage.getItem("authToken") || null,
            userProfile: Cookies.get("userProfile") ? JSON.parse(Cookies.get("userProfile")) : null,
            sidebarPermit: Cookies.get("sidebarPermit") ? JSON.parse(Cookies.get("sidebarPermit")) : null,
            error: null,
            successMessage: null,
            password: '',
            confirmPassword: '',
            showPassword: false,
            showConfirmPassword: false,
            isLoading: false,
            isMobile: window.innerWidth < 768,
            refCode: '',
            ut: ''
        };
    }

    handleResize = () => {
        this.setState({ isMobile: window.innerWidth < 768 });
    };

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);

        const searchParams = new URLSearchParams(this.props.location.search);
        const refCode = searchParams.get('refCode');
        const ut = searchParams.get('ut');
        this.setState({ refCode: refCode, ut: ut })
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState({
            [name]: type === 'checkbox' ? checked : value,
            error: null,
            successMessage: null,
        });
    };

    validate = () => {
        const { password, confirmPassword } = this.state;

        if (!password) {
            this.setState({ error: 'กรุณากรอกรหัสผ่านใหม่' });
            return false;
        }
        if (password.length < 8) {
            this.setState({ error: 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร' });
            return false;
        }
        if (password !== confirmPassword) {
            this.setState({ error: 'รหัสผ่านไม่ตรงกัน กรุณาตรวจสอบอีกครั้ง' });
            return false;
        }
        return true;
    };

    getCsrfToken = () => {
        requester.get("/public/csrf-token")
            .then((response) => {
                const csrfToken = response.data.csrfToken;
                localStorage.setItem("csrfToken", csrfToken);
                this.setState({ csrfToken }, () => {
                    this.submitResetPassword();
                });
                util.debug(this.state, 'GET-CSRF-TOKEN-SUCCESS', csrfToken);
            })
            .catch((error) => {
                console.error("Error fetching CSRF Token", error);
                this.setState({
                    error: "ไม่สามารถดำเนินการได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง",
                    isLoading: false,
                });
                util.debug(this.state, 'GET-CSRF-TOKEN-FAIL');
            });
    };

    submitResetPassword = () => {
        const { password, refCode, ut, csrfToken } = this.state;
        

        requester.post("/public/view/reset-password", {
            password: password, refCode: refCode, ut: ut, 
        }, {
            headers: { 'X-CSRF-Token': csrfToken },
        })
            .then((response) => {                
                if(response?.data?.status === 200){
                    this.setState({
                        isLoading: false,
                        successMessage: 'เปลี่ยนรหัสผ่านสำเร็จ กรุณาเข้าสู่ระบบด้วยรหัสผ่านใหม่',
                        password: '',
                        confirmPassword: '',
                    });
                    util.debug(this.state, 'RESET-PASSWORD-SUCCESS');
                }else{
                    const msg = 'เกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่';
                    this.setState({ error: msg, isLoading: false });
                    util.debug(this.state, 'RESET-PASSWORD-FAIL');
                }
            })
            .catch((error) => {
                const msg = error?.response?.data?.message || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง';
                this.setState({ error: msg, isLoading: false });
                util.debug(this.state, 'RESET-PASSWORD-FAIL');
            });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        if (!this.validate()) return;
        this.setState({ isLoading: true, error: null, successMessage: null }, () => {
            this.getCsrfToken();
        });
    };

    render() {

        const {
            password, confirmPassword,
            showPassword, showConfirmPassword,
            error, successMessage, isLoading, isMobile,
            refCode, ut
        } = this.state;

        const direct =
                ut === 'O' ? '/back-office' :
                ut === 'E' ? '/external-users' :
                '';
                
        const colorTheme = ut === "O" ? '#0E3362' : '#f99e39';       

        return (
            <>
                <Container fluid className="vh-100 d-flex">
                    <Row className="flex-fill">

                        {/* Left Side */}
                        <Col
                            md={4}
                            className="d-flex flex-column justify-content-between align-items-center text-white"
                            style={{
                                backgroundColor: '#eae9e5',
                                backgroundImage: `url(${leftSideBg})`,
                                padding: '5%',
                                backgroundSize: isMobile ? '100%' : '100% auto',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                textAlign: 'center',
                                height: isMobile ? '35%' : '',
                            }}
                        >
                            <div className="text-center" style={{ marginTop: '-30px' }}>
                                {!isMobile && (
                                    <img
                                        src={logoOrange}
                                        alt="EEC Logo"
                                        style={{
                                            width: '65%',
                                            filter: 'drop-shadow(-10px 6px 12px rgba(0,0,0,0.35))',
                                        }}
                                    />
                                )}
                            </div>
                        </Col>
                        <Col md={1} />

                        {/* Right Side */}
                        <Col md={7} className="d-flex flex-column justify-content-center" style={{ padding: '10%' }}>
                            <div className="mb-4">
                                <h3 className="text-orange fw-bold" style={{ color: colorTheme }}>EEC มีงานทำ</h3>
                                <h5 className="fw-normal">เปลี่ยนรหัสผ่าน</h5>
                                {/* <h6 className="fw-normal" style={{ color: '#A5A5A5' }}>debug ref: {refCode}</h6>
                                <h6 className="fw-normal" style={{ color: '#A5A5A5' }}>debug type: {ut}</h6> */}
                            </div>

                            <Form onSubmit={this.handleSubmit}>

                                {/* รหัสผ่านใหม่ */}
                                <Form.Group className="mb-3">
                                    <Form.Label>รหัสผ่านใหม่</Form.Label>
                                    <Row>
                                        <Col xs={12} md={9} lg={9}>
                                            <div style={{ position: 'relative' }}>
                                                <Form.Control
                                                    type={showPassword ? 'text' : 'password'}
                                                    placeholder="******"
                                                    name="password"
                                                    value={password}
                                                    onChange={this.handleInputChange}
                                                    disabled={isLoading}
                                                    style={{ paddingRight: '2.5rem', height: '45px' }}
                                                />
                                                <i
                                                    className={showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'}
                                                    onClick={() => this.setState({ showPassword: !showPassword })}
                                                    style={{
                                                        position: 'absolute', right: '12px',
                                                        top: '50%', transform: 'translateY(-50%)',
                                                        cursor: 'pointer', color: '#6c757d', fontSize: '1.1rem',
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>ยืนยันรหัสผ่าน</Form.Label>
                                    <Row>
                                        <Col xs={12} md={9} lg={9}>
                                            <div style={{ position: 'relative' }}>
                                                <Form.Control
                                                    type={showConfirmPassword ? 'text' : 'password'}
                                                    placeholder="******"
                                                    name="confirmPassword"
                                                    value={confirmPassword}
                                                    onChange={this.handleInputChange}
                                                    disabled={isLoading}
                                                    style={{ paddingRight: '2.5rem', height: '45px' }}
                                                />
                                                <i
                                                    className={showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'}
                                                    onClick={() => this.setState({ showConfirmPassword: !showConfirmPassword })}
                                                    style={{
                                                        position: 'absolute', right: '12px',
                                                        top: '50%', transform: 'translateY(-50%)',
                                                        cursor: 'pointer', color: '#6c757d', fontSize: '1.1rem',
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Form.Group>

                                {error && (
                                    <Row className="mt-2">
                                        <Col xs={12} md={9} lg={9}>
                                            <Alert variant="danger" style={{ fontSize: '14px' }}>
                                                {error}
                                            </Alert>
                                        </Col>
                                    </Row>
                                )}

                                {successMessage && (
                                    <Row className="mt-2">
                                        <Col xs={12} md={9} lg={9}>
                                            <Alert variant="success" style={{ fontSize: '14px' }}>
                                                {successMessage}{' '}
                                                <a href={direct} className="text-orange fw-bold">เข้าสู่ระบบ</a>
                                            </Alert>
                                        </Col>
                                    </Row>
                                )}

                                <Row className="mt-4">
                                    <Col xs={12} md={9} lg={9}>
                                        <Button
                                            type="submit"
                                            className="w-100 p-2"
                                            disabled={isLoading}
                                            style={{ backgroundColor: colorTheme, border: 'none' }}
                                        >
                                            {isLoading ? (
                                                <>
                                                    <span
                                                        className="spinner-border spinner-border-sm me-2"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                    กำลังดำเนินการ...
                                                </>
                                            ) : 'เปลี่ยนรหัสผ่าน'}
                                        </Button>
                                    </Col>
                                </Row>

                            </Form>
                        </Col>

                    </Row>
                </Container>

                <SendEmailResetPassword ref={ref => (this.resetModal = ref)} />
            </>
        );
    }
}

export default withRouter(ResetPassword);